import React from "react";
import "./GlobalContacts.css";

const GlobalContacts = () => {
  return (
    <section className="connect">
      <div className="connect-frame-92">
        <div className="connect-frame-32">
          <h2 className="connect-heading">Lighting up homes and businesses </h2>
          <h2 className="connect-heading1">Reach out to Bixton!</h2>
          <div className="connect-rectangle"></div>
          <p className="connect-subheading">
            We’re here to brighten your day! Whether you have questions about
            our products, need assistance, or want to share feedback, we’re just
            a message away.
          </p>
        </div>
        <div className="connect-frame-95">
          <div className="connect-frame-93">
            <label className="connect-label" htmlFor="email">
              Email Address <span className="contact-star">*</span>
            </label>
            <div className="connect-frame-3">
              <input
                id="email"
                className="connect-input"
                type="email"
                placeholder="example@bixton.lk"
              />
            </div>
          </div>
          <div className="connect-frame-94">
            <label className="connect-label" htmlFor="subject">
              Subject <span className="contact-star">*</span>
            </label>
            <div className="connect-frame-3">
              <input
                id="subject"
                className="connect-input"
                type="text"
                placeholder="Enter your subject here (e.g., Product Inquiry, Warranty Request)"
              />
            </div>
          </div>
          <div className="connect-frame-96">
            <label className="connect-label" htmlFor="message">
              Message <span className="contact-star">*</span>
            </label>
            <div>
              <textarea
                id="message"
                className="connect-textarea"
                placeholder="Type your message here (e.g., I would like more details about your energy-efficient lamps.)"
              ></textarea>
            </div>
          </div>
          <button className="connect-button">Send Now</button>
        </div>
      </div>
    </section>
  );
};

export default GlobalContacts;
